export default __webpack_public_path__ + "static/media/007-cry.4dce0e36.svg";